import React, { Component } from 'react';
import { Card, Col, message, Row } from 'antd';
import { browserHistory } from 'react-router';
import Process from '@comm/workflow/Process';
import Opration from '@comm/workflow/WorkflowOp';
import ProcessHistory from '@comm/workflow/ProcessHistory';
import Comment from '@comm/comment/Index';

import {
  queryCallbackPayment,
  queryNextPayment,
  queryReturnPayment,
  querySavePayment,
} from '@api/finance/payment';
import FormOpen from './FormOpen';

class Page extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dataInfo: {},
      isLoading: false,
    };
  }

  componentWillMount() {
    const { data } = this.props;
    this.setState({ dataInfo: data });
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataInfo: nextProps.data,
    });
  }

  /**
   * 提交付款
   */
  handSubmit = (item, type) => {
    if (type === 'save') {
      this.savePayment(item);
    }
  };

  /**
   * 保存
   */
  savePayment = item => {
    querySavePayment(item).then(res => {
      if (res.statusCode === 200) {
        message.success('保存成功');
        browserHistory.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 处理流程
   */
  doTask = (pass, refuse) => {
    const { dataInfo } = this.state;
    const instance = dataInfo.instance || {};
    const item = {
      instanceUuid: instance.uuid,
    };
    switch (pass) {
      case 'callback':
        this.callbackPayment(item);
        break;
      case 'next':
        this.nextPayment(item);
        break;
      case 'return':
        this.returnPayment(item, refuse);
        break;
      default:
        break;
    }
  };

  // 收回
  callbackPayment = params => {
    queryCallbackPayment(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  // 通过
  nextPayment = params => {
    this.setState({ isLoading: true });
    queryNextPayment(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.setState({ isLoading: false });
        browserHistory.go(-1);
      } else {
        message.error(res.message);
        this.setState({ isLoading: false });
      }
    });
  };

  // 打回
  returnPayment = (params, refuse) => {
    queryReturnPayment({
      ...params,
      ...refuse,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  handleCancel = () => {};

  /**
   * 查看流程
   */
  watchTask = () => {};

  render() {
    const { dataInfo, isLoading } = this.state;
    const instance = dataInfo.instance || {};
    const histories = dataInfo.histories || [];
    return (
      <div>
        <Opration
          data={dataInfo}
          handSubmit={this.handSubmit}
          doTask={this.doTask}
          watchTask={this.watchTask}
          isLoading={isLoading}
        />
        <FormOpen
          data={dataInfo}
          handSubmit={this.handSubmit}
          doTask={this.doTask}
          watchTask={this.watchTask}
          {...this.props}
        />
        <Card title="流程跟踪">
          <Row justify="center">
            <Col span={24} style={{ marginBottom: '16px', fontSize: '14px' }}>
              <div style={{ marginBottom: '16px', fontSize: '14px' }}>流程路径：</div>
              <Process instance={instance} />
            </Col>
            <Col span={24}>
              <ProcessHistory dataSource={histories} />
            </Col>
          </Row>
        </Card>
        <Comment target={{ type: 'payment', uuid: dataInfo.uuid }} />
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/finance/payment/PageOpen.js